$.fn.bookDescription = function(options) {
  let self = this;

  $(window).on('resize load orientationchange', function() {
    var tallest = 0
    self.css('--description-min-height', tallest + 'px')
    self.find('.card-product--description__description').each(function( index ) {
      height = $(this).outerHeight()
      if(height > tallest ) {
        tallest = height;
      }
    });
    self.css('--description-min-height', tallest + 'px')
  })

  return function() {
    return self
  }()
}
